import { Lightning } from "@lightningjs/sdk";
export var VideoPlayerEventNames;
(function (VideoPlayerEventNames) {
    VideoPlayerEventNames["Abort"] = "Abort";
    VideoPlayerEventNames["AdEnd"] = "AdEnd";
    VideoPlayerEventNames["AdStart"] = "AdStart";
    VideoPlayerEventNames["CanPlay"] = "CanPlay";
    VideoPlayerEventNames["CanPlayThrough"] = "CanPlayThrough";
    VideoPlayerEventNames["Clear"] = "Clear";
    VideoPlayerEventNames["DurationChange"] = "DurationChange";
    VideoPlayerEventNames["Emptied"] = "Emptied";
    VideoPlayerEventNames["Encrypted"] = "Encrypted";
    VideoPlayerEventNames["Ended"] = "Ended";
    VideoPlayerEventNames["Error"] = "Error";
    VideoPlayerEventNames["InterruptBegin"] = "InterruptBegin";
    VideoPlayerEventNames["InterruptEnd"] = "InterruptEnd";
    VideoPlayerEventNames["LoadedData"] = "LoadedData";
    VideoPlayerEventNames["LoadedMetadata"] = "LoadedMetadata";
    VideoPlayerEventNames["LoadStart"] = "LoadStart";
    VideoPlayerEventNames["Pause"] = "Pause";
    VideoPlayerEventNames["Play"] = "Play";
    VideoPlayerEventNames["Playing"] = "Playing";
    VideoPlayerEventNames["Progress"] = "Progress";
    VideoPlayerEventNames["Ratechange"] = "Ratechange";
    VideoPlayerEventNames["Seeked"] = "Seeked";
    VideoPlayerEventNames["Seeking"] = "Seeking";
    VideoPlayerEventNames["Stalled"] = "Stalled";
    VideoPlayerEventNames["TimeUpdate"] = "TimeUpdate";
    VideoPlayerEventNames["VolumeChange"] = "VolumeChange";
    VideoPlayerEventNames["Waiting"] = "Waiting";
})(VideoPlayerEventNames || (VideoPlayerEventNames = {}));
export class VideoPlayerBase extends Lightning.Component {
}
export default VideoPlayerBase;
//# sourceMappingURL=VideoPlayerBase.js.map